import React, { useEffect, useRef, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import {RiDeleteBin6Line} from 'react-icons/ri'
import { useDelete } from '../../../hooks'
import { MwSpinner, MwSpinnerButton, NoDataFound } from '../../../components/ui'
import { useTranslation } from 'react-i18next'
import { AiOutlineDelete } from 'react-icons/ai'
import { MdEdit } from 'react-icons/md'
import { CiViewList, CiViewTable } from 'react-icons/ci'
import DeleteConfirmationModal from '../../../components/OsRequisition/RequisitionComponents/DeleteConfirmationModal'

const StockTakingListItem = ({item,index,reload}) => {
    const [t,i18n ] = useTranslation('global')
    const isRTL = i18n.dir() === 'rtl';
    const menuRef = useRef(null)
        const addOptionsRef = useRef(null);
    const {data:deleteResult ,loading:deleteLoading,deleteItem} = useDelete()
        const [showAddOptions, setShowAddOptions] = useState(false)
    const [menuVisible, setMenuVisible] = useState(null);
    const [selectedUnitId, setSelectedUnitId] = useState(null);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
 
    const params = useParams();
    const deleteHandeler = (id) => {
        deleteItem(`${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/stocktaking/master/${id}`)
    }
    useEffect(() => {
        if (deleteResult) {
            reload();
        }
    }, [deleteResult])
    const toggleMenu = (id) => {
        setMenuVisible(prev => prev === id ? null : id);
    };
    const handleDelete = (id, e) => {
        e.preventDefault();
        e.stopPropagation();
        setSelectedUnitId(id); // إضافة هذه السطر لتحديد العنصر المراد حذفه
        setDeleteModalOpen(true);
    };
     useEffect(() => {
            const handleClickOutside = (event) => {
                if (addOptionsRef.current && !addOptionsRef.current.contains(event.target)) {
                    setShowAddOptions(false);
                }
                const menuItem = event.target.closest('button, a');
                if (menuItem) return;
                if (menuRef.current && !menuRef.current.contains(event.target)) {
                    setMenuVisible(null);
                }
            };
            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, []);

        if (!item ) {
            return (
              <NoDataFound msg={t('stocktaking.no_data_available')} />
            );
          }
         
 

    return (
        <>
        
        {deleteLoading ? (
            <MwSpinnerButton withLabel={false} isFullCenter={true} />
        ) : (
            <Link
            to={`/${params.tenant}/stocktakings/view-table/${item?.id}`}
            key={item?.id}
          >
            <div
              className={`grid grid-cols-12 gap-3 border-t px-4 py-2    hover:bg-indigo-50 hover:font-bold cursor-pointer items-center ${
                menuVisible === item.id ? "" : "hover:bg-indigo-50 hover:font-bold"
              }`}
            >
              <div className="text-[#251658] col-span-1 text-xs text-center">
                {index + 1}
              </div>
              <div className="text-[#251658] col-span-2 text-xs text-center">
                {item?.code}
              </div>
              <div className="text-[#251658] col-span-3 text-xs  ">
                {item?.warehouse?.name_ar}
              </div>
              <div className="text-[#251658] col-span-3 text-xs  ">
                {item?.warehouse?.name_en}
              </div>
              <div className="text-[#251658] col-span-1 text-xs text-center">
                {!item?.completed &&
                  item?.stocktaking_at &&
                  new Date(item.stocktaking_at).toLocaleDateString("en-EG")}
              </div>
              <div
                className="flex justify-center text-[#251658] col-span-2 text-sm text-center relative"
                onClick={(e) => e.preventDefault()}
              >
                <div className="relative" ref={menuRef}>
                  <div className="flex items-center gap-4">
                    {item?.completed ? (
                      <div className="inline-flex items-center gap-1 py-1 px-1 bg-green-100 text-green-700 rounded-full text-xs">
                         {t("stocktaking.Settlement_Completed")}
                      </div>
                    ) : (
                      <div className="inline-flex items-center gap-1 py-1 px-2 bg-gray-100 text-gray-700 rounded-full text-xs">
                        {t("stocktaking.Settlement_Pending")}
                      </div>
                    )}
                    <button
                      className="text-[#251658] hover:text-slate-700 p-1 transition-colors"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        toggleMenu(item.id);
                      }}
                    >
                      ⋮
                    </button>
                  </div>
        
                  {menuVisible === item.id && (
                    <div
                      className={`absolute ${
                        isRTL ? "left-0" : "right-0"
                      } top-10 bg-white shadow-lg rounded-md border border-gray-300 min-w-[150px] z-10`}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <Link
                        to={`/${params.tenant}/stocktakings/view-table/${item?.id}`}
                        onClick={() => setMenuVisible(null)}
                        className="block w-full"
                      >
                        <div className="flex items-center gap-2 text-left px-4 py-2 text-sm text-slate-700 hover:bg-gray-100 w-full">
                          <CiViewTable className="w-5 h-5" />
                          {t("stocktaking.view")}
                        </div>
                      </Link>
                      <Link
                        to={`/${params.tenant}/stocktakings/show/${item?.id}`}
                        onClick={() => setMenuVisible(null)}
                        className="block w-full"
                      >
                        <div className="flex items-center gap-2 text-left px-4 py-2 text-sm text-slate-700 hover:bg-gray-100 w-full">
                          <MdEdit className="w-5 h-5" />
                          {t("stocktaking.edit_add")}
                        </div>
                      </Link>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          handleDelete(item.id, e);
                        }}
                        className="flex items-center gap-2 text-left px-4 py-2 text-sm text-red-500 hover:bg-gray-100 w-full"
                      >
                        <AiOutlineDelete className="w-5 h-5" />
                        {t("requisition.delete")}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Link>
        )}
        
        <DeleteConfirmationModal
          isOpen={deleteModalOpen}
          onClose={() => {
              setDeleteModalOpen(false);
              setSelectedUnitId(null);
          }}
          onConfirm={() => {
              deleteHandeler(selectedUnitId);
              setDeleteModalOpen(false);
          }}
          loading={deleteLoading}
      />
    </>
);
    
}

export default StockTakingListItem